export default __webpack_public_path__ + "static/media/wishlist.c16a0b12.svg";